export default __webpack_public_path__ + "static/media/screen_livechat_05.65f91409.png";